import React from 'react'

import moment from 'moment';

import { withRouter } from 'react-router-dom';

import { Section, Table, InfosBar, ExternalLink, Text, Empty } from 'components';
import { Container, Button, Icon } from 'semantic-ui-react'

import { ModalClinic } from 'modals';

import { BreadcrumbHelper, Functions, Typeof } from 'utils';

import './style.css';

const CLINICS_PER_PAGE = 10;

class ClinicListScene extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      clinics: props.clinics,
      clinicCriteria: '',
      showClinicCreateModal: false
    };

    this.handleClinicSearch = this.handleClinicSearch.bind(this);

    this.toggleClinicCreateModal      = this.toggleClinicCreateModal.bind(this);
    this.handleClinicCreateModalClose = this.handleClinicCreateModalClose.bind(this);

    this.handleClinicSelect = this.handleClinicSelect.bind(this);
  }

  componentWillMount() {

    BreadcrumbHelper.reset();
    BreadcrumbHelper.push('Accueil', '/');
    BreadcrumbHelper.push('Cliniques');
    BreadcrumbHelper.flush();

    const params = new Map(this.props.location.search.slice(1).split('&').map(kv => kv.split('=')))

    if(params.has('s')) {
      this.setState({
        clinicCriteria: params.get('s').trim()
      });
    }
  }

  handleClinicSearch(criteria) {

    this.setState({
      clinicCriteria: criteria
    });
  }

  toggleClinicCreateModal() {
    this.setState({
      showClinicCreateModal: !this.state.showClinicCreateModal
    });
  }

  handleClinicCreateModalClose(clinic) {

    if(Typeof.object(clinic)) {
      clinic.devices = [];

      let clinics = [...this.state.clinics];
      clinics.push(clinic);

      this.setState({
        clinics: clinics
      });
    }

    this.toggleClinicCreateModal();
  }

  handleClinicSelect(clinic) {

    //Navigate to clinic page
    this.props.history.push(`/clinics/${clinic.id}`);
  }

  render() {

    const { clinics } = this.state;

    let columns = [
      {
        id: 'name',
        header: 'Nom',
        value: (clinic) => clinic.name,
        render: (clinic, value) => <Text style={{"capitalize" : true}}>{value}</Text>,
        fit: true
      },
      {
        id: 'email',
        header: 'Adresse e-mail',
        value: (clinic) => clinic.email,
        render: (clinic, email) => (
          <ExternalLink target={`mailto:${email}`}>
            <Icon name="mail" />
            {email}
          </ExternalLink>
        ),
        fit: true
      },
      {
        id: 'phone_number',
        header: 'Numéro de tél.',
        value: (clinic) => clinic.phone,
        render: (clinic, phone) => (
          <ExternalLink target={`tel:${phone}`}>
            <Icon name="phone" />
            {Functions.formatPhone(phone)}
          </ExternalLink>
        ),
        fit: true
      },
      {
        id: 'address',
        header: 'Adresse',
        value: (clinic) => [clinic.address, clinic.zip_code, clinic.city],
        render: (clinic, values) => `${values[0]}, ${values[1]} ${values[2]}`
      },
      {
        id: 'devices',
        header: 'Valise(s)',
        value: (clinic) => clinic.devices.length,
        fit: true
      },
      {
        id: 'examens',
        header: "Examen(s)",
        value: (clinic) => clinic.examens.length,
        fit: true
      },
      {
        id: 'last_examen',
        header: "Dernier examen",
        value: (clinic) => {
          const examens = clinic.examens.sort((a,b)=> a.date_create > b.date_create)
          return examens.slice(-1).length > 0 ? examens.slice(-1)[0].date_create : 0
        },
        render: (clinic) => {
          const examens = clinic.examens.sort((a,b)=> a.date_create > b.date_create)
          const date = examens.slice(-1).length > 0 ? examens.slice(-1)[0].date_create : undefined
          return Typeof.number(date) ? 
          <div>
            <Text style={{"mono" : true}}>
              {moment(new Date(date * 1000)).format('[Le] DD/MM/YYYY [à] HH:mm:ss')}
            </Text>
            <p>
              {examens.slice(-1)[0].horse.name}
            </p>
          </div>
             : <Empty />
        },
        fit: true
      },
    ];

    return (
      <React.Fragment>
        <Container>

          {/* Clinics */}
          <Section title="Cliniques" onSearch={this.handleClinicSearch} criteria={this.state.clinicCriteria} actions={[

            // Add clinic
            <Button icon="add" content="Nouveau" onClick={this.toggleClinicCreateModal} key={0} />
          ]}>

            {clinics.length > 0 ? (

              <React.Fragment>

                {/* Number of available clinics */}
                <InfosBar mode="column">
                  <span>{clinics.length > 1 ? `${clinics.length} cliniques disponibles` : '1 clinique disponible'}</span>
                </InfosBar>

                {/* Clinics list */}
                <Table columns={columns}
                  criteria={this.state.clinicCriteria}
                  items={clinics}
                  itemsPerPage={CLINICS_PER_PAGE}
                  onSelect={this.handleClinicSelect}
                  messageEmpty="Aucun clinique ne correspond à votre recherche"
                />

              </React.Fragment>

            ) : (

              // No clinic available
              <InfosBar mode="row">
                <span>Aucun clinique disponible</span>
              </InfosBar>

            )}

          </Section>

        </Container>

        {/* Modal create clinic */}
        {this.state.showClinicCreateModal &&
          <ModalClinic onClose={this.handleClinicCreateModalClose} />
        }

      </React.Fragment>
    );
  }
}

export default withRouter(ClinicListScene);
